import { toast } from 'sonner';
import { parseError } from './parse';
import { checkAppVersion } from '../version';
import { showSaveFailedRefreshModal } from '../refresh-modal';

const VERSION_ERROR_TITLES = [
  'Error saving project',
];

export const handleError = async (title: string, error: unknown) => {
  const description = parseError(error);

  // If the error looks like a version mismatch, check version BEFORE showing toast
  // We check specific titles (like saving)
  const isSuspicious = VERSION_ERROR_TITLES.includes(title);

  if (isSuspicious && typeof window !== 'undefined') {
    try {
      const hasNewVersion = await checkAppVersion();
      if (hasNewVersion) {
        // If new version found, trigger modal and SKIP the error toast
        window.dispatchEvent(new Event('show_version_modal'));
        return;
      }
    } catch {
      // ignore check error, proceed to show original error
    }
  }

  // Saving failures are high-risk for stale state; show the dedicated refresh modal for consistency.
  if (title === 'Error saving project' && typeof window !== 'undefined') {
    try {
      showSaveFailedRefreshModal();
      return;
    } catch {}
  }

  toast.error(title, { description });

  // For other errors, still trigger a background check just in case
  if (!isSuspicious && typeof window !== 'undefined') {
    try { window.dispatchEvent(new Event('check_version')); } catch {}
  }
};
